<script setup lang="ts">
import { computed } from 'vue';
import usuarioSelect from '~/graphql/usuarioSelect.graphql';
import { CompromissoForm } from '~/lib/fw';
import { useAuthenticationStore } from '~/stores/authenticationStore';

interface Props {
  pastaCodigos?: string[];
  compromisso?: any;
  fluxo?: any;
}

const props = defineProps<Props>();

const emit = defineEmits(['close']);

const authenticationStore = useAuthenticationStore();
const buttonsDisabled = computed(() => {
  if (!props.compromisso) {
    return false;
  }
  return authenticationStore.user!.id !== props.compromisso.responsavelCodigo;
});
</script>

<template>
  <CompromissoForm
    action="transferencia-responsavel-processual-para-outra-area/aprovar-transferencia-responsavel-processual-para-outra-area"
    :pasta-codigos="props.pastaCodigos ?? []"
    :compromisso-codigos="props.compromisso ? [props.compromisso.codigo] : []"
    :wait-for-result="true"
    :show-upload-files="true"
    :submit-button-disabled="buttonsDisabled"
    @close="() => emit('close')"
  >
    <template #form="{ model }">
      <a-form-item
        label="Aprovado?"
        name="aprovado"
        :rules="[
          {
            message: 'Aprovar é obrigatório',
            required: true,
            trigger: 'change',
          },
        ]"
      >
        <a-radio-group v-model:value="model.aprovado">
          <a-radio-button :value="true"> Sim </a-radio-button>
          <a-radio-button :value="false"> Não </a-radio-button>
        </a-radio-group>
      </a-form-item>

      <a-form-item
        v-if="model.aprovado"
        name="responsavel"
        label="Novo responsável"
        :rules="[
          {
            message: 'Novo responsável é obrigatório',
            required: true,
            trigger: 'change',
            type: 'object',
          },
        ]"
      >
        <GqlSelect
          v-model:value="model.responsavel"
          :query="usuarioSelect"
          placeholder="Selecione o novo responsável"
          :allow-clear="true"
          :variables="{
            where: {
              ativo: {
                eq: true,
              },
            },
            order: [
              {
                nome: 'ASC',
              },
            ],
          }"
        />
      </a-form-item>

      <a-form-item
        label="Observação"
        name="observacao"
        :rules="
          model.aprovado === false
            ? [{ message: 'Observação é obrigatória', required: true }]
            : []
        "
      >
        <a-textarea v-model:value="model.observacao" :rows="4" />
      </a-form-item>
    </template>
  </CompromissoForm>
</template>
